import { ChevronDown } from "lucide-react";
import Dropdown from "./Dropdown";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import { setLocalStorage } from "../helpers/browserStorage";
import PageForm from "../../pages/components/PageForm";

function getSidebarOptions() {
  const sidebarOptions = [
    {
      label: "Your pages",
      routeTo: "/pages",
    },
    {
      label: "Components",
      routeTo: "/components",
      checkActive: (pathname) => {
        return ["/components", "/component-form"].includes(pathname);
      },
    },
    // {
    //   label: "Incidents",
    //   routeTo: "/incidents",
    //   checkActive: (pathname) => {
    //     return ["/incidents", "/component-form"].includes(pathname);
    //   },
    // },
    {
      label: "Incidents",
      routeTo: "/view_incidents",
      checkActive: (pathname) => {
        return ["/view_incidents", "/component-form"].includes(pathname);
      },
    },
    {
      label: "Subscribers",
      routeTo: "/subscribers",
      checkActive: (pathname) => {
        return ["/subscribers", "/subscribers"].includes(pathname);
      },
    },
    {
      label: "Status embed",
      routeTo: "/statusEmbed",
      checkActive: (pathname) => {
        return ["/statusEmbed", "/statusEmbed"].includes(pathname);
      },
    },
  ];

  return sidebarOptions;
}

function Sidebar({ pages, refetchPages }) {
  const location = useLocation();
  const { pathname } = location;
  const { pageId, isOwner } = useApp();
  const page = pages.find((page) => page._id === pageId);

  const sidebarOptions = getSidebarOptions();

  return (
    <div className="fixed pt-6 text-white sidebar-width h-full overflow-auto px-4">
      <PageDropdown pages={pages} refetchPages={refetchPages} />

      <div className="mt-8 w-full">
        {sidebarOptions?.map((option, i) => {
          const { label, routeTo, checkActive } = option;

          const isActive = checkActive
            ? checkActive(pathname)
            : pathname === routeTo;
          if (label === "View status page") {
            return (
              <Link
                to={"/status-page/" + page?.url}
                target="_blank"
                className={`text-white py-2 px-3 my-0.5 nav_link ${
                  isActive ? "nav_link shadow-inner" : ""
                } w-full inline-block rounded-md`}
                key={i}
              >
                {label}
              </Link>
            );
          } else {
            return (
              <Link
                to={routeTo}
                className={`text-white py-2 px-3 my-0.5 nav_link ${
                  isActive ? "nav_link shadow-inner" : ""
                } w-full inline-block rounded-md`}
                key={i}
              >
                {label}
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
}

export default Sidebar;

function refactorPageMenus(pages = [], pageId, setOpenCreatePage, isOwner) {
  const menus = [];

  pages.forEach((page) => {
    if (page?._id === pageId) {
      return;
    }

    menus.push({
      label: page?.name,
      onClick: () => {
        setLocalStorage("pageId", page?._id);
        window.location.reload();
      },
    });
  });

  if (isOwner) {
    menus.push({
      label: "+ Create page",
      onClick: () => setOpenCreatePage(true),
    });
  }

  return menus;
}

function PageDropdown({ pages = [], refetchPages }) {
  const { pageId, isOwner } = useApp();

  const [openCreatePage, setOpenCreatePage] = useState(false);

  const menus = refactorPageMenus(pages, pageId, setOpenCreatePage, isOwner);

  const page = pages.find((page) => page._id === pageId);

  return (
    <div>
      <Dropdown
        label={
          <div className="border border-white rounded-md p-2 px-3 flex items-center justify-between nav_link">
            {page?.name || "No Pages"}

            <ChevronDown />
          </div>
        }
        menus={menus}
        optionCls="top-12 left-0 w-full"
      />

      <PageForm
        open={openCreatePage}
        setOpen={setOpenCreatePage}
        onSuccess={refetchPages}
      />
    </div>
  );
}
